import { createReducer } from 'src/helpers/reducer';
import { ISkillApplicationsState, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';

const initState: ISkillApplicationsState = {
  skillApplications: undefined,
  isLoading: false,
  isActionLoading: false,
  total: 0,
};

function onLoadSkillApplicationsRequest(state: ISkillApplicationsState): ISkillApplicationsState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSkillApplicationsSuccess(
  state: ISkillApplicationsState,
  { payload }: { payload: ILoadDataSuccessPayload },
): ISkillApplicationsState {
  const { skillApplications, total, filteredTotal } = payload;

  return {
    ...state,
    skillApplications,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadSkillApplicationsError(state: ISkillApplicationsState) {
  return {
    ...state,
    isLoading: false,
  };
}

function onProcessActionRequest(state: ISkillApplicationsState) {
  return {
    ...state,
    isActionLoading: true,
  };
}

function onProcessActionSuccess(state: ISkillApplicationsState) {
  return {
    ...state,
    isActionLoading: false,
  };
}

function onProcessActionError(state: ISkillApplicationsState) {
  return {
    ...state,
    isActionLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_SKILL_APPLICATIONS_REQUEST]: onLoadSkillApplicationsRequest,
  [actionsTypes.LOAD_SKILL_APPLICATIONS_SUCCESS]: onLoadSkillApplicationsSuccess,
  [actionsTypes.LOAD_SKILL_APPLICATIONS_ERROR]: onLoadSkillApplicationsError,
  [actionsTypes.PROCESS_ACTION_REQUEST]: onProcessActionRequest,
  [actionsTypes.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actionsTypes.PROCESS_ACTION_ERROR]: onProcessActionError,
});
